import React, { useState, useEffect } from "react";
import './forget-password.css';
import '../set-password/set-password.css';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Carousel from '../../reusable-components/carousel/Carousel';
import { useNavigate } from "react-router-dom";
import axios, { Axios } from 'axios';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import Footer from "../../reusable-components/footer/footer";
import BaseURL from '../../utils/base-uri.json';
import MuiAlert from '@mui/material/Alert';
import Snackbar from '@mui/material/Snackbar';
import { ToastContainer, toast } from "react-toastify";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";

import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import InputAdornment from '@mui/material/InputAdornment';
import FormControl from '@mui/material/FormControl';
import OutlinedInput from '@mui/material/OutlinedInput';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import IconButton from "@mui/material/IconButton";
import { Tooltip } from "@mui/material";


const toastNotify = (message, isSuccess = true) => {
    if (isSuccess) {
        toast.success(message, {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
        });
    } else {
        toast.error(message, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
        });
    }
};
function ForgetPassword(props) {
    const params = new URLSearchParams(window.location.search);
    const UserId = params.get("UserId");

    const navigate = useNavigate();
    const [Email, setEmail] = React.useState("");
    const [open, setOpen] = React.useState(false);
    const [password, setPassword] = React.useState("");
    const [confirmPassword, setConfirmPassword] = React.useState("");
    const [openError, setOpenError] = React.useState(false);
    const [loader, setloader] = React.useState(false);
    const [UserIdfromEmp, setUserIdfromEmp] = React.useState('');
    const [Trg, setTrg] = React.useState(false);

    // const Alert = React.forwardRef(function Alert(props, ref) {
    //     return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
    // });

    useEffect(() => {
        // console.log('this is the apiheader: ', JSON.stringify(BaseURL.apiHeaders));
        if (UserId || UserIdfromEmp) {
            document.getElementById("forgetPassword").classList.add("hideDiv");
            document.getElementById("checkEmail").classList.add("hideDiv");
            document.getElementById("newPassword").classList.remove("hideDiv");
        }
    }, [UserIdfromEmp]);

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpen(false);
        setOpenError(false);
    };


    const sendChangePasswordRequest = () => {
        let item = Email;
        setloader(true)
        axios.get(BaseURL.baseUrl + BaseURL.forgetPassword.checkUser + item)
            .then(response => {
                if (response?.data?.responseCode == 100) {
                    if (response?.data?.responseMessage == "Redirect to Forgot password") {
                        setUserIdfromEmp(response?.data?.data?.userId);
                        setTrg(!Trg);
                    } else {
                        document.getElementById("forgetPassword").classList.add("hideDiv");
                        document.getElementById("checkEmail").classList.remove("hideDiv");
                        //setUserId(response.data.data.UserId);
                        toastNotify("Success", true);
                    }
                } else {
                    setOpenError(true);
                    // alert(response.data.responseMessage);
                    toastNotify(response?.data?.responseMessage, false);
                }
            }).catch((error) => {
                console.log(error?.response?.data);
            }).finally(() => {
                setloader(false)
            });

    }

    const changePasswordRedirect = () => {
        document.getElementById("checkEmail").classList.add("hideDiv");
        document.getElementById("newPassword").classList.remove("hideDiv");
    }

    const backtoemail = () => {
        document.getElementById("checkEmail").classList.add("hideDiv");
        document.getElementById("forgetPassword").classList.remove("hideDiv");

    }
    const validationSchema = Yup.object().shape({
        NewPassword: Yup.string()
            .required('New password is required !')
            .matches(/^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$ %^&*-]).{10,}$/, 'Minimum 10 characters, at least one upper case letter, one lower case letter, one number, and one special character'),
        ConfirmPassword: Yup.string()
            .required('Confirm password is required !')
            .oneOf([Yup.ref('NewPassword'), null], 'Confirm password does not match !'),

    });

    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);

    const {
        register,
        handleSubmit,
        formState: { errors }
    } = useForm({
        resolver: yupResolver(validationSchema)
    });

    const [values, setValues] = React.useState({
        password: '',
        showNewPassword: false,
        showConfirmPassword: false
    });


    const handleClickShowPassword1 = () => {
        setValues({
            ...values,
            showNewPassword: !values?.showNewPassword
        });
    };
    const handleMouseDownPassword1 = (event) => {
        event?.preventDefault();
    };

    const handleClickShowPassword2 = () => {
        setValues({
            ...values,
            showConfirmPassword: !values?.showConfirmPassword
        });
    };
    const handleMouseDownPassword2 = (event) => {
        event?.preventDefault();
    };


    const onSubmit = (data) => {
        let ResetPasswordModel = {
            userId: UserId == null ? UserIdfromEmp : UserId,
            NewPassword: data?.NewPassword,
            ConfirmPassword: data?.ConfirmPassword
        }
        axios.post(BaseURL.baseUrl + BaseURL.forgetPassword.resetPassword, ResetPasswordModel, BaseURL.apiHeaders)
            .then(response => {
                if (response?.data?.responseCode == 100) {
                    toastNotify("Success", true);
                    document.getElementById("passwordReady").classList.remove("hideDiv");
                    document.getElementById("newPassword").classList.add("hideDiv");
                    setEmail('')

                } else {
                    toastNotify(response?.data?.responseMessage, false);
                }
            })
    }

    return (
        <>
            <ToastContainer />
            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={loader}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
            <div className="first-verify__loginContainer">
                <div className='first-verify__leftContainer'>
                    <div className='first-verify__logo'></div>
                    {/* <Snackbar open={openError} autoHideDuration={6000} onClose={handleClose}>
                        <Alert severity="error" onClose={handleClose} >Error Ocurred, please try again!</Alert>
                    </Snackbar> */}
                    <div className='first-verify__loginSubContainer'>
                        <div id="newPassword" className="first-verify__newPasswordContainer hideDiv">
                            <div className="first-verify__logoContainer"></div>
                            <span className='first-verify__loginHeading' id="setPassword">{props.content.setPassword.setNewPassword}</span>
                            <span className='first-verify__loginSubheading'>{props.content.setPassword.passwordBanner}</span>
                            <div className='first-verify__logindetails'>
                                <span className='password-label'>{props.content.setPassword.password}</span>
                                <Tooltip
                                    placement="top"
                                    title={
                                        <div >
                                            <h6><div class='controlHintText'>Your password must meet the following requirements:<br />At least 10 characters long<br />Contain at least 1 uppercase letter<br />Contain at least 1 lowercase letter<br />Contain at least 1 number <br />Contain at least 1 special character</div></h6>
                                        </div>
                                    }
                                    arrow
                                >
                                    <FormControl sx={{ width: '300px' }} variant="outlined">
                                        <OutlinedInput
                                            id="NewPassword"
                                            sx={{
                                                "& legend": { display: "none" },
                                                "& fieldset": { top: 0 },
                                                width: "380px"
                                            }}
                                            type={values?.showNewPassword ? 'text' : 'password'}
                                            inputProps={{ className: "login-password" }}
                                            placeholder={props.content.setPassword.passwordLabel}
                                            // error={errors.firstName ? true : false}
                                            {...register("NewPassword")}
                                            variant="outlined"
                                            required
                                            endAdornment={
                                                <InputAdornment position="end" sx={{
                                                    '&$focused $notchedOutline': {
                                                        borderColor: '#2EFF22',
                                                        borderWidth: 1,
                                                    },
                                                }}>
                                                    <IconButton
                                                        id="outlined-basic"
                                                        aria-label="toggle password visibility"
                                                        onClick={handleClickShowPassword1}
                                                        onMouseDown={handleMouseDownPassword1}
                                                        edge="end"
                                                    >
                                                        {values?.showNewPassword ? <VisibilityOff /> : <Visibility />}
                                                    </IconButton>
                                                </InputAdornment>
                                            }
                                        />
                                    </FormControl>
                                </Tooltip>
                                <p className='text-danger mx-2 mt-1' >
                                    {errors?.NewPassword?.message}
                                </p>
                                {/* <TextField id="outlined-basic" sx={{
                                    '& legend': { display: 'none' },
                                    '& fieldset': { top: 0 },
                                }} type={"password"} onChange={e => setPassword(e.target.value)} inputProps={{ className: "login-password" }} placeholder={props.content.setPassword.passwordLabel} variant="outlined" /> */}
                                <span className='password-label'>{props.content.setPassword.updatePassword}</span>
                                <FormControl sx={{ width: '300px' }} variant="outlined">
                                    <OutlinedInput
                                        id="ConfirmPassword"
                                        sx={{
                                            "& legend": { display: "none" },
                                            "& fieldset": { top: 0 },
                                            width: "380px"
                                        }}
                                        type={values?.showConfirmPassword ? 'text' : 'password'}
                                        inputProps={{ className: "login-password" }}
                                        // error={errors.firstName ? true : false}
                                        {...register("ConfirmPassword")}
                                        placeholder={props.content.setPassword.updatePassword}
                                        variant="outlined"
                                        required
                                        endAdornment={
                                            <InputAdornment position="end" sx={{
                                                '&$focused $notchedOutline': {
                                                    borderColor: '#2EFF22',
                                                    borderWidth: 1,
                                                },
                                            }}>
                                                <IconButton
                                                    id="outlined-basic"
                                                    aria-label="toggle password visibility"
                                                    onClick={handleClickShowPassword2}
                                                    onMouseDown={handleMouseDownPassword2}
                                                    edge="end"
                                                >
                                                    {values?.showConfirmPassword ? <VisibilityOff /> : <Visibility />}
                                                </IconButton>
                                            </InputAdornment>
                                        }
                                    />
                                </FormControl>
                                <p className='text-danger mx-2 mt-1' >
                                    {errors?.ConfirmPassword?.message}
                                </p>
                                {/* <TextField sx={{
                                    '& legend': { display: 'none' },
                                    '& fieldset': { top: 0 },
                                }} id="outlined-basic" type={"password"} onChange={e => setConfirmPassword(e.target.value)} inputProps={{ className: "login-password" }} placeholder={props.content.setPassword.passwordLabel} variant="outlined" /> */}
                            </div>
                            <div className='first-verify__logindetails padding-top-0 text-align-center'>
                                <Button variant="contained" className="login-button" onClick={handleSubmit(onSubmit)} sx={{ textTransform: "capitalize", padding: "15px" }} >{props.content.setPassword.resetPassword}</Button>
                                <Button variant="outlined" className="login-button-backtologin" onClick={() => navigate("/login")}><ArrowBackIcon />{props.content.setPassword.backToLogin}</Button>
                            </div>
                        </div>
                        <div id="checkEmail" className="first-verify__checkEmailContainer hideDiv">
                            <div className="first-verify__emaillogoContainer"></div>
                            <span className='first-verify__loginHeading'>{props.content.setPassword.checkEmail}</span>
                            <span className='first-verify__loginSubheading'>
                                {props.content.setPassword.passwordSend} <span style={{ fontWeight: 600, color: "#000", }}>{Email}</span>
                            </span>
                            <div className='first-verify__logindetails' style={{ display: "flex", flexWrap: "wrap", justifyContent: "center" }}>
                                {/* <Button variant="contained" className="login-button margin-bottom-10" onClick={changePasswordRedirect} sx={{textTransform:"capitalize",padding:"15px"}} >{props.content.setPassword.checkEmail}</Button> */}
                                <span className="button-caption mx-2">{props.content.setPassword.emailNotReceived}</span><span className="button-hyperlink" style={{ cursor: "pointer" }} onClick={backtoemail}>{props.content.setPassword.clickToResend}</span>
                                <br />
                                <Button variant="outlined" className="login-button-backtologin text-center" onClick={() => navigate("/login")}><ArrowBackIcon />{props.content.setPassword.backToLogin}</Button>

                            </div>
                        </div>
                        <div id="forgetPassword" className="first-verify__forgetPasswordContainer">
                            <div className="first-verify__logoContainer"></div>
                            <span className='first-verify__loginHeading'>{props.content.setPassword.forgetPassword}</span>
                            <span className='first-verify__loginSubheading'>
                                {props.content.setPassword.resetInstructions}
                            </span>
                            <div className='first-verify__logindetails'>
                                <span className='password-label'>{props.content.setPassword.email}</span>
                                <TextField sx={{
                                    '& legend': { display: 'none' },
                                    '& fieldset': { top: 0 },
                                }} id="outlined-basic" type={"string"} placeholder={props.content.setPassword.enterEmailPlaceholder} onChange={e => setEmail(e.target.value)} inputProps={{ className: "login-password" }} variant="outlined" />
                            </div>
                            <div className='first-verify__logindetails padding-top-0 text-align-center'>
                                <Button variant="contained" className="login-button" onClick={sendChangePasswordRequest} sx={{ textTransform: "capitalize", padding: "15px" }} >{props.content.setPassword.resetPassword}</Button>
                                <Button variant="outlined" className="login-button-backtologin" onClick={() => navigate("/login")}><ArrowBackIcon />{props.content.setPassword.backToLogin}</Button>
                            </div>
                        </div>
                        <div id="passwordReady" className="first-verify__passwordSuccessful hideDiv">
                            <div className="first-verify__successlogoContainer"></div>
                            <span className='first-verify__loginHeading'>{props.content.setPassword.resetPassword}</span>
                            <span className='first-verify__loginSubheading2'>
                                {props.content.setPassword.resetSuccess}
                                <br />
                                {props.content.setPassword.resetSuccess1}
                            </span>
                            <div className='first-verify__logindetails'>
                                <Button variant="contained" className="login-button margin-bottom-10" onClick={() => navigate("/login")} sx={{ textTransform: "capitalize", padding: "15px" }} >{props.content.setPassword.continue}</Button>
                            </div>
                        </div>
                    </div>
                    <Footer />
                </div>
                <div className='first-verify__rightContainer'>
                    <div className='first-verify__rightSubContainer'>
                        <div className='first-verify__carousel-container'>
                            <Carousel />
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ForgetPassword;

